import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from '../../components/AppIcon';
import AgentLayout from '../agent-dashboard/AgentLayout';

const NAV = [
  { to: '/agent-dashboard', label: 'Dashboard', icon: 'LayoutDashboard' },
  { to: '/workspace', label: 'Workspace hub', icon: 'Layers', exact: true },
  { to: '/workspace/co-broker', label: 'Co-Brokering', icon: 'Users' },
  { to: '/workspace/crm', label: 'CRM', icon: 'Contact' },
  { to: '/notice-board', label: 'Notice Board', icon: 'ClipboardList' },
  { to: '/workspace/bookings', label: 'Bookings', icon: 'Calendar' },
  { to: '/workspace/documents', label: 'E-Sign', icon: 'FileText' },
];

/** Collaboration tools share the professional agent console chrome. */
const WorkspaceShell = ({ title, subtitle, children }) => {
  const location = useLocation();

  return (
    <AgentLayout title={title} subtitle={subtitle}>
      <div className="flex flex-wrap gap-2 mb-6">
        {NAV.map((item) => {
          const active = item.exact
            ? location.pathname === item.to
            : location.pathname === item.to ||
              (item.to !== '/workspace' && location.pathname.startsWith(item.to));
          return (
            <Link
              key={item.to}
              to={item.to}
              className={`inline-flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium transition-colors border ${
                active
                  ? 'bg-slate-900 text-white border-slate-900'
                  : 'bg-white text-slate-600 border-slate-200 hover:border-slate-300'
              }`}
            >
              <Icon name={item.icon} size={16} />
              {item.label}
            </Link>
          );
        })}
      </div>
      {children}
    </AgentLayout>
  );
};

export default WorkspaceShell;
